/**
 * Allowed message-reaction KEYS — mirrors the server allowlist
 * (`functions/src/constants/emoji.ts`). Reactions render as monochrome Lucide icons
 * (`reactionIcons.tsx`), not colorful emoji, to keep the UI grayscale. Keep the lists in sync.
 */
export const ALLOWED_REACTIONS = [
  'clap', 'up', 'love', 'laugh', 'idea', 'fire', 'eyes', 'check',
] as const;

/** One stored reaction. `emoji` holds the reaction KEY (e.g. 'love') — a stable id, not a glyph. */
export interface MessageReaction { emoji: string; by: string; name: string }

/** Group a flat reaction list by key → { emoji(key), names[], count, mine } for rendering. */
export function groupReactions(reactions: MessageReaction[] | undefined, myId?: string) {
  const byKey = new Map<string, { emoji: string; names: string[]; mine: boolean }>();
  for (const r of reactions || []) {
    const g = byKey.get(r.emoji) || { emoji: r.emoji, names: [], mine: false };
    g.names.push(r.name);
    if (myId && r.by === myId) g.mine = true;
    byKey.set(r.emoji, g);
  }
  return Array.from(byKey.values()).map((g) => ({ ...g, count: g.names.length }));
}
